import React from "react";
import Header from "../components/Common/Header/Header";
import JWTCOMMON from "../components/Common/JWTCommon";
import Sidenavigation from "../components/Common/Sidenavigation";

const MainContainer = (props) => {
  return (
    <>
      <JWTCOMMON />
      <div className="dashboard">
        <div className="sidebar">
          <Sidenavigation active={props.active} />
        </div>
        <div className="wrapper">
          <Header />
          <main className={`${props.className} main`}>{props.children}</main>
        </div>
      </div>
    </>
  );
};
export default MainContainer;
